import React from 'react';
import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import { Upload, FileText, File, CheckCircle } from 'lucide-react';

const Container = styled.div`
  width: 100%;
  height: 100%;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const UploadZone = styled(motion.div)`
  width: 300px;
  height: 200px;
  background: #ffffff;
  border: 2px dashed #e5e7eb;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const IconWrapper = styled(motion.div)`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  margin-bottom: 16px;
`;

const Text = styled.p`
  font-size: 14px;
  color: #6b7280;
  text-align: center;
  
  strong {
    color: #111827;
    font-weight: 600;
  }
`;

const FloatingFile = styled(motion.div)`
  position: absolute;
  background: #ffffff;
  padding: 12px;
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #374151;
  border: 1px solid #e5e7eb;
  z-index: 10;
`;

const SuccessOverlay = styled(motion.div)`
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
`;

const FilesVisual: React.FC = () => {
    return (
        <Container>
            <UploadZone>
                <IconWrapper>
                    <Upload size={24} />
                </IconWrapper>
                <Text>
                    <strong>Click to upload</strong> or drag and drop<br />
                    PDF, DOCX, TXT
                </Text>

                <FloatingFile
                    initial={{ x: -100, y: -50, opacity: 0, rotate: -10 }}
                    animate={{ x: 0, y: 0, opacity: 1, rotate: 0 }}
                    transition={{ duration: 0.8, delay: 0.5 }}
                >
                    <FileText size={16} color="#ef4444" />
                    knowledge-base.pdf
                </FloatingFile>

                <FloatingFile
                    initial={{ x: 100, y: 50, opacity: 0, rotate: 10 }}
                    animate={{ x: 0, y: 0, opacity: 1, rotate: 0 }}
                    transition={{ duration: 0.8, delay: 0.8 }}
                    style={{ marginTop: '40px' }}
                >
                    <File size={16} color="#3b82f6" />
                    product-manual.docx
                </FloatingFile>

                <SuccessOverlay
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 2, duration: 0.5 }}
                >
                    <motion.div
                        initial={{ scale: 0 }}
                        animate={{ scale: 1 }}
                        transition={{ delay: 2.2, type: "spring" }}
                    >
                        <CheckCircle size={48} color="#10b981" />
                    </motion.div>
                    <motion.p
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 2.4 }}
                        style={{ marginTop: 12, fontWeight: 600, color: '#111827' }}
                    >
                        Files Processed!
                    </motion.p>
                </SuccessOverlay>
            </UploadZone>
        </Container>
    );
};

export default FilesVisual;
